/** Schritt 1 „Stelle“. */
const wizJobDE = {
  wizJobTitle: 'Um welche Stelle geht es?',
  wizJobSubtitle:
    'Füge die Stellenanzeige ein oder beschreibe die Rolle in ein paar Sätzen. Daraus baut SAIA Suche und Nachrichten.',
  wizJobDescriptionLabel: 'Stellenbeschreibung',
  wizJobDescriptionPlaceholder:
    'z. B. Senior Backend Entwickler (m/w/d) in München, hybrid. 5+ Jahre Java und Spring Boot, Erfahrung mit Microservices. Deutsch fließend.',
  wizJobLinkButton: 'Link zur Anzeige einfügen',
  wizLinkTitle: 'Stellenanzeige per Link einlesen',
  wizLinkHint: 'Wir lesen den Text der Anzeige aus.',
  wizLinkInvalid: 'Bitte gib einen gültigen Link ein (https://…).',
  wizLinkReplaces: 'Der Text im Anzeigenfeld wird durch die eingelesene Anzeige ersetzt.',
  wizLinkCancel: 'Abbrechen',
  wizLinkSubmit: 'Einlesen',
  wizJobReadingUrl: 'Anzeige wird gelesen …',
  wizJobReadUrlError: 'Die Anzeige konnte nicht gelesen werden.',
  wizJobCheckButton: 'Anzeige mit KI prüfen',
  wizJobChecking: 'SAIA prüft deine Stellenanzeige …',
  wizJobCheckError: 'Die Anzeige konnte gerade nicht geprüft werden.',
  wizJobAdTitle: 'Stellenanzeige: {{title}} · {{score}} von {{total}} Punkten',
  wizJobLevel1: 'Zu dünn',
  wizJobLevel2: 'Ausbaufähig',
  wizJobLevel3: 'Gut',
  wizJobLevel1Desc: 'Damit findet SAIA kaum passende Kandidaten. Ergänze die fehlenden Punkte.',
  wizJobLevel2Desc: 'Funktioniert, aber mit mehr Angaben werden Suche und Nachrichten genauer.',
  wizJobLevel3Desc: 'Genug Informationen für Suche, Bewertung und Nachrichten.',
  wizJobFixAll: 'Fehlendes ergänzen',
  wizJobStale: 'Angaben geändert – erneut prüfen',
  wizJobAddOne: 'Ergänzen',
  wizJobFillIn: 'Eintragen',
  wizJobAdded: 'Ergänzt',
  wizJobSourceAi: 'Geprüft von SAIA (KI)',
  wizJobSourceHeuristic: 'KI nicht erreichbar – Schnellprüfung',
  wizJobCheckPresent: 'Vorhanden.',
  wizJobCheckMissing: 'Fehlt in der Anzeige.',
  wizJobNotSentHint:
    'Die Anzeige wird nicht 1:1 an die Talente geschickt – SAIA nutzt Anzeige und Ergänzungen als Grundlage für Suche, Bewertung und Nachrichten.',
  wizJobExtrasLabel: 'Ergänzungen & Optimierungen',
  wizJobExtrasPlaceholder:
    'Zusätzliche Fakten zur Stelle, die in der Anzeige fehlen – z. B. Benefits, Anforderungen oder Besonderheiten. Vorschläge der KI-Prüfung landen hier.',
  wizJobExtrasHint:
    'Fließt in KI-Prüfung, Suche, Bewertung und Nachrichten ein, ohne die Original-Anzeige zu verändern. Trage nur Fakten ein, die stimmen.',
  wizJobTitleFieldLabel: 'Jobtitel',
  wizJobTitleFieldPlaceholder: 'z. B. Senior Backend Entwickler (m/w/d)',
  wizJobTitleFieldHint:
    'Steht in Nachrichten und Suche für den Jobtitel. Leer: SAIA leitet ihn aus der Anzeige ab.',
  wizJobNameLabel: 'Kampagnenname',
  wizJobNamePlaceholder: 'z. B. Senior Backend Entwickler (m/w/d) – München',
  wizJobAccountLabel: 'Absender (LinkedIn-Account)',
  wizJobAccountPlaceholder: 'Konto wählen',
  wizJobSimilar: 'Ähnliche Stelle schon mal besetzt?',
  wizJobUseTemplate: 'Vorhandene Kampagne als Vorlage nutzen',
  wizJobCloneTitle: 'Vorhandene Kampagne als Vorlage nutzen',
  wizJobCloneIntro:
    'Briefing, Bewertungskriterien und Ansprache der gewählten Kampagne werden übernommen. Hat die Vorlage kein Briefing, musst du die Stelle neu beschreiben. Du kannst alles danach anpassen.',
  wizJobCloneSelect: 'Kampagne',
  wizJobCloneSelectPlaceholder: 'Kampagne wählen',
  wizJobCloneContacts: 'Kandidaten mit übernehmen',
  wizJobCloneNone: 'Es gibt noch keine Recruiting-Kampagne, die du als Vorlage nutzen kannst.',
  wizJobCloneLoadError: 'Die Kampagnen konnten nicht geladen werden.',
  wizJobCloneNameSuffix: '(Kopie)',
  wizJobCloneCancel: 'Abbrechen',
  wizJobCloneConfirm: 'Als Vorlage nutzen',
  wizJobCloneError: 'Die Kampagne konnte nicht kopiert werden.',
};
export default wizJobDE;
